var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',{staticClass:"pa-1"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }